import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <div>
        <AppRoutes />
      </div>
      <Footer/>
    </Router>
  );
}

export default App;
